import {
  Skeleton,
  AspectRatio,
  CSSObject,
  VStack,
  HStack,
} from '@chakra-ui/react'
import { SpringValue } from 'react-spring'

import { AnimatedGrid } from '@/lib/springComponent'

interface Props {
  id?: string
  style?: Partial<Record<keyof CSSObject, SpringValue>>
  direction?: 'row' | 'column'
}

function BlogItem({
  id,
  style,
  direction = 'column',
}: Props): React.ReactElement {
  return (
    <AnimatedGrid
      id={id}
      templateColumns={direction === 'column' ? '1fr' : '11fr 9fr'}
      rowGap={4}
      columnGap={7}
      sx={{
        alignItems: 'stretch',
        opacity: 0.8,
      }}
      style={style}
    >
      <AspectRatio ratio={264 / 138}>
        <Skeleton startColor="primary.400" endColor="secondary.400" />
      </AspectRatio>
      <VStack alignItems="left">
        <Skeleton
          startColor="primary.400"
          endColor="secondary.400"
          sx={{
            h: {
              base: 'var(--chakra-fontSizes-md)',
              sm: 'var(--chakra-fontSizes-xl)',
            },
          }}
        />
        {direction === 'row' && (
          <Skeleton
            startColor="primary.400"
            endColor="secondary.400"
            sx={{
              h: {
                base: 32,
                sm: 40,
              },
              mb: '16px !important',
            }}
          />
        )}
        <Skeleton
          startColor="primary.400"
          endColor="secondary.400"
          sx={{
            h: {
              base: 'var(--chakra-fontSizes-sm)',
              sm: 'var(--chakra-fontSizes-md)',
            },
            w: '25%',
          }}
        />
        <HStack>
          {[...Array(3)].map((_, idx) => (
            <Skeleton
              startColor="primary.400"
              endColor="secondary.400"
              key={idx}
              sx={{
                h: {
                  base: 'var(--chakra-fontSizes-md)',
                  sm: 'var(--chakra-fontSizes-xl)',
                },
                w: '10%',
              }}
            />
          ))}
        </HStack>
      </VStack>
    </AnimatedGrid>
  )
}

export default BlogItem
